
import React from 'react';

//MUI componenets
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

//redux hooks and tools
import { useSelector, useDispatch } from "react-redux";
import { getRidingPeriod } from "../../../../store/selectors.js";
// PB Boucle infinie : import { dureeSlice } from "../../../../store/dureeSlice.js";

import calculDuree from '../../../../utils/calcul_duree.js'
import { prepareDureeTexte } from '../../../../utils/calcul_duree.js'

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function DisplayDuree() {
    const dispatch = useDispatch();
    const periode = useSelector(getRidingPeriod); //global state : id of the selected spot
    const lang = useSelector(getLang) //global state : language

    let infosDuree = "-"

    if (periode[1][0] !== 0 && periode[1][1] !== 0) {
        //ATTN boucle infinie //dispatch(dureeSlice.actions.setDuree(calculDuree(periode))); 
        infosDuree = prepareDureeTexte(calculDuree(periode));
    }

    return (
        <Card className='card-duree-loc'>
            {infosDuree !== '-' ? //if form not invalid, display duree
                <CardContent>
                    <p>{translator("Durée de location :", lang, "dureeLocation")} </p>
                    <h5>{infosDuree}</h5>
                </CardContent>
                : null} {/* else display nothing */}
        </Card>

    )
}



export default DisplayDuree


